import { render, staticRenderFns } from "./InstallPWAMobileWizard.vue?vue&type=template&id=6d9703d2"
import script from "./InstallPWAMobileWizard.vue?vue&type=script&lang=ts"
export * from "./InstallPWAMobileWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports